import { mapState } from 'vuex'

export default {
  props: {
    boardId: { type: String, required: true }
  },
  computed: {
    ...mapState(['boardMetas', 'company']),
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    },
    isListMode () {
      return this.$route.name.endsWith('List')
    },
    isCreateMode () {
      return this.$route.name.endsWith('Create')
    },
    isEditMode () {
      return this.$route.name.endsWith('Edit')
    },
    isViewMode () {
      return this.$route.name.endsWith('View')
    },
    isAnswerMode () {
      return this.$route.name.endsWith('Answer')
    },
    boardMeta () {
      return this.boardMetas[this.boardId]
    },
    boardName () {
      return this.boardMeta.boardName
    },
    boardDeco () {
      return this.boardMeta.boardDeco
    },
    useOptions () {
      console.log('useOptions-----------------------', this.boardId, this.boardMeta)
      return this.boardMeta.useOptions
    },
    boardTheme () {
      const mode = this.isAdminMode ? 'admin' : (this.$mq === 'mobile' ? 'mobile' : 'user')
      const { theme } = this.boardMeta
      if (theme.hasOwnProperty(mode)) {
        return theme[mode]
      } else if (theme.hasOwnProperty('user')) {
        return theme['user']
      } else {
        return {
          list: { type: 'table' }
        }
      }
    },
    // container () {
    //   console.log('this.company.theme', this.company.theme)
    //   if (this.isAdminMode) {
    //     return this.company.theme.adminContainer
    //   } else {
    //     return this.company.theme.userContainer
    //   }
    // },
    answerFlag () {
      return !!(this.useOptions.hasOwnProperty('answerFlag') && this.useOptions.answerFlag === 'Y')
    },
    filterFlag () {
      return !!(this.useOptions.hasOwnProperty('filterFlag') && this.useOptions.filterFlag === 'Y')
    },
    downloadFlag () {
      return !!(this.useOptions.hasOwnProperty('downloadFlag') && this.useOptions.downloadFlag === 'Y')
    }
  }
}
// answerFlag() {
//   console.log('this.useOptions', this.useOptions)
//   return !!(this.useOptions.hasOwnProperty('answerFlag') && this.useOptions.answerFlag === 'Y')
// },
// filterFlag() {
//   return !!(this.useOptions.filterFlag && this.useOptions.filterFlag === 'Y')
// },
// downloadFlag() {
//   return !!(this.useOptions.downloadFlag && this.useOptions.downloadFlag === 'Y')
// },

// },
// mode () {
//   let mode = ''
//   if (this.isListMode) {
//     mode = 'list'
//   } else if (this.isViewMode) {
//     mode = 'view'
//   } else if (this.isAnswerMode) {
//     mode = 'edit'
//   } else if (this.isEditMode) {
//     mode = 'edit'
//   } else if (this.isCreateMode) {
//     mode = 'edit'
//   } else {
//     console.log('BUG!!!!!!!!!!!!!! Unknow mode')
//   }
//   return mode
